// extracted by mini-css-extract-plugin
export var containerStyle = "slider-module--containerStyle--F_lPf";
export var prevStyle = "slider-module--prevStyle--3XLYo";
export var nextStyle = "slider-module--nextStyle--1Cidi";
export var viewportStyle = "slider-module--viewportStyle--3tav6";
export var carouselStyle = "slider-module--carouselStyle--3EPQc";
export var slideStyle = "slider-module--slideStyle--3x1h9";